import axios from 'axios';
import config from '../../config';
import tokenApi from './tokenApi';

const mainPageInstance = axios.create({
    baseURL: config.api,
    headers: {
        'Content-Type': 'application/json'
    }
});

class MainpageApi {
    static addRecord() {
        return mainPageInstance.post('/record')
            .then(function (response) {
                // console.log(response)
                return response.data;
            })
            .catch(function (error) {
                throw (error);
            });
    };
};

export default MainpageApi;